import React from "react";
import { motion } from "framer-motion";

export const Inclusions = ({ t }) => {
  return (
    <section
      data-testid="inclusions-section"
      className="relative bg-[#e7e7e5] text-stone-900 py-32 md:py-48"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.2 }}
          className="max-w-3xl mb-20 md:mb-28"
        >
          <p className="text-[11px] uppercase tracking-[0.4em] text-stone-500 mb-6">
            {t.inclusions.label}
          </p>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight">
            {t.inclusions.heading}{" "}
            <span className="italic text-stone-500">
              {t.inclusions.headingItalic}
            </span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-16 gap-y-14 md:gap-y-16">
          {t.inclusions.items.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.9, delay: 0.04 * i }}
              className="border-t border-stone-300/70 pt-7"
              data-testid={`inclusion-${i}`}
            >
              <h3 className="font-serif text-2xl md:text-3xl font-light text-stone-900 mb-3 leading-tight">
                {item.title}
              </h3>
              <p className="text-stone-600 text-sm md:text-base font-light leading-[1.8]">
                {item.desc}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
